import AttributeItem, { AttributeGrid } from 'dashboard/components/AttributeItem';
import { ReportBusinessNonprofit } from 'dashboard/models/report/business-nonprofit';
import { ReportSnapshotBusinessNonprofit } from 'dashboard/models/report-snapshot';

interface BusinessNonprofitProps {
  report: ReportBusinessNonprofit | ReportSnapshotBusinessNonprofit;
  isRedacted: boolean;
}

export const BusinessNonprofit = ({
  report: {
    attributes: {
      query: { ein: ein },
    },
  },
  isRedacted,
}: BusinessNonprofitProps) => {
  return (
    <AttributeGrid>
      <AttributeItem title='EIN' value={ein} placeholder='N/A' isRedacted={isRedacted} />
    </AttributeGrid>
  );
};
